// src/pages/Productos.js
import React from "react";
import productos from "../productos";
import CardProducto from "../components/CardProducto";

export default function Productos() {
  return (
    <section>
      <h2 className="text-3xl font-bold mb-6">Nuestros Productos</h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
        {productos.map((producto) => (
          <CardProducto key={producto.id} producto={producto} />
        ))}
      </div>
    </section>
  );
}
